/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { Observable } from "rxjs";
import { AlertController } from "@ionic/angular";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { JwtAuthService } from "./../../services/jwt-auth/jwt-auth.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner/ngx";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-register",
	templateUrl: "register.page.html",
	styleUrls: ["register.page.scss"],
})

export class RegisterPage {

	// search query
	filterQuery: string = "";

	
	pageName:string = `register` ;
	
	/**
	* RegisterPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public alertController: AlertController,
		public formBuilder: FormBuilder,
		public jwtAuthService: JwtAuthService,
		public barcodeScanner: BarcodeScanner,
		public popoverController: PopoverController,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleBlackOpaque();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#0955b3");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	

		console.log(`RegisterPage`,`pageName`,this.pageName);
	}
	
	/**
	* RegisterPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	formRegister: FormGroup;
	
	responseToken: Observable<any>;
	responseDataToken: any = [];
	
	
	/**
	* RegisterPage.initFields()
	**/
	public initFields(){
		this.formRegister = this.formBuilder.group({
			username: ["", Validators.required],
			email: ["", Validators.required],
			password: ["", Validators.required],
			birthday: ["", Validators.required],
			//url: ["", Validators.required],
			first_name: ["", Validators.required],
			//last_name: ["", Validators.required],
			//company: ["", Validators.required],
			//address_1: ["", Validators.required],
			//address_2: ["", Validators.required],
			city: ["", Validators.required],
			//state: ["", Validators.required],
			//postcode: ["", Validators.required],
			//country: ["", Validators.required],
			//phone: ["", Validators.required],
		});
	}
	
	
	/**
	* RegisterPage.onSubmit()
	**/
	public onSubmit(){
		this.responseToken = this.jwtAuthService.register(this.formRegister.value);
		this.responseToken.subscribe(data =>{
			if(data && data.message && data.title ){
				this.showAlert(data.title,null,data.message);
			}
			
		});
	}
	
	
	/**
	* RegisterPage.ngOnInit()
	**/
	public ngOnInit(){
		this.initFields();
	}
	
	
	/**
	* RegisterPage.showAlert()
	**/
	async showAlert(header:string, subheader: string, message: string){
		const alert = await this.alertController.create({
			header: header,
			subHeader: subheader,
			message: message,
			buttons: [
				{
					text: `Ok!`,
					handler: (data) => {
						this.router.navigate(["/login"]);
					}
				}
			]
		});
		await alert.present();
	}
	
	
	
	/**
	* RegisterPage:filterItems($event)
	* @param any $event
	*
	* @required for searchbar
	**/
	public filterItems(evt: any) {
		let filterVal = evt.target.value;
		if (filterVal && filterVal.trim() !== ""){
			// your code here
			this.filterQuery = filterVal.toLowerCase();
		}
		return true;
	}
	




}
